import { Container as MUIContainer } from '@mui/material'
import React from 'react'
import PropTypes from "prop-types";
import Header from './Header';
import Content from './Content';
import AlertComponent from './Alert';
import LoadingComponent from './Loading';

function Container(props) {
    const { children, subHeader, message, showHeader, showProcessing, bg } = props;
    return (
        <>
            {showHeader && <Header />}
            <MUIContainer>
                {subHeader}
                <Content>
                    {children}
                </Content>
                {message && message.show && <AlertComponent
                    isOpen={message.show}
                    message={message.content}
                    otherMessage={message.otherMessage ? message.otherMessage : null}
                    onClose={message.callBackFn}
                />}
                {showProcessing && <LoadingComponent showLoading={showProcessing} />}
            </MUIContainer>
        </>
    )
}

Container.propTypes = {
    subHeader: PropTypes.element,
    showHeader: PropTypes.bool,
    showProcessing: PropTypes.bool,
    message: PropTypes.object,
}

export default Container;